<template>
  <v-app>
    <app-drawer />
    <app-bar />
    <v-main>
      <ConfirmDialog />
      <NotifyContainer />
      <v-card tile class="sticky-breadcrumbs">
        <v-breadcrumbs class="py-2" :items="breadcrumbsItems">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              exact
              :to="{ name: item.name, query: item.query }"
            >
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
          <template v-slot:divider>
            <v-icon>mdi-chevron-{{ $vuetify.rtl ? "left" : "right" }}</v-icon>
          </template>
        </v-breadcrumbs>
      </v-card>
      <v-progress-linear absolute indeterminate :active="loading" />
      <v-container fluid class="px-6">
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>
    <app-footer />
  </v-app>
</template>
<script>
import { mapState } from "vuex";
import AppDrawer from "./AppDrawer.vue";
import AppBar from "./AppBar.vue";
import { loadingComputed } from "@/vuex/helpers";
import NotifyContainer from "@/components/NotifyContainer.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import AppFooter from "./AppFooter.vue";

export default {
  name: "AppLayout",
  components: {
    AppDrawer,
    AppBar,
    NotifyContainer,
    ConfirmDialog,
    AppFooter,
  },
  data() {
    return {
      routeName: null,
    };
  },
  computed: {
    ...mapState(["drawer", "breadcrumbsItems"]),
    ...loadingComputed,
  },
};
</script>
